import React, { useEffect } from 'react';
import { Header } from './Header';
import { NewFeaturesSection } from './NewFeaturesSection';
import { Footer } from './Footer';

export const SolutionsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <NewFeaturesSection />
      </main>
      <Footer />
    </div>
  );
};
